module.exports = "<gg-checkbox ng-model=\"model[options.key]\">\n  {{to.label}}\n  {{to.required ? '*' : ''}}\n  <gg-info-icon text=\"{{to.help}}\" placement=\"{{to.helpTextPlacement}}\" ng-if=\"to.help && to.helpTextPlacement\"></gg-info-icon>\n  <gg-info-icon text=\"{{to.help}}\" placement=\"right\" ng-if=\"to.help && !to.helpTextPlacement\"></gg-info-icon>\n</gg-checkbox>"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/formly/checkbox.html
 ** module id = 538
 ** module chunks = 0
 **/